import { Reveal } from "./Reveal";
import { Formline } from "./Formline";
import { Check } from "lucide-react";

const BENEFITS = [
  "Professional, licensed security personnel",
  "A safety-first approach",
  "Clear communication and detailed reporting",
  "Respectful interactions with employees, contractors, and the public",
  "Reliable security solutions tailored to each site",
];

export const WhyChooseUs = () => (
  <section
    id="why-us"
    data-testid="why-us-section"
    className="relative py-24 md:py-32 bg-[color:var(--surface)] border-y border-white/10 overflow-hidden"
  >
    <Formline className="absolute -right-24 top-0 w-[400px] h-[400px] rotate-6" opacity={0.05} />

    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <span className="text-xs font-bold uppercase tracking-[0.24em] text-[color:var(--primary-text)]">
            Why Choose Us
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Professional security you can{" "}
            <span className="font-editorial italic">depend on</span>.
          </h2>
          <p className="mt-8 text-lg md:text-xl text-secondary leading-relaxed">
            Chowat Security Services Inc. provides dependable security solutions tailored to the
            needs of each client. Whether protecting industrial facilities, construction sites,
            commercial properties, community events, or critical infrastructure, our team is
            committed to delivering professional service with consistency and accountability.
          </p>
        </Reveal>

        <div className="lg:col-span-7 lg:pt-14">
          <Reveal>
            <p className="text-lg md:text-xl text-white/90">
              We believe that every client deserves:
            </p>
          </Reveal>

          <ul className="mt-8 space-y-4">
            {BENEFITS.map((b, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <li
                  data-testid={`why-us-benefit-${i + 1}`}
                  className="flex items-start gap-4 border-t border-white/10 pt-4"
                >
                  <span className="mt-0.5 flex-shrink-0 flex items-center justify-center h-7 w-7 rounded-sm bg-[color:var(--primary)]/15 text-[color:var(--primary-text)]">
                    <Check size={16} strokeWidth={3} />
                  </span>
                  <span className="text-lg text-secondary leading-relaxed">{b}</span>
                </li>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.1}>
            <p className="mt-10 font-display text-xl md:text-2xl leading-snug tracking-tight">
              Our goal is to become a{" "}
              <span className="text-[color:var(--primary-text)]">trusted security partner</span> —
              not simply a security provider.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
